export default {
    imageDashboardTransaction: {
        action: 'Handling',
        transactionId: 'Transaktions ID',
        variationCount: 'Antal variationer',
        date: 'Dato',
        cost: 'Omkostning',
        description: 'Beskrivelse',
        selectedImage: 'Udvalgt billede',
        goTo: 'Gå til',
    },
};
